import { Text, View } from "react-native";
import { CircleIcon, Icon } from "ui/gluestack/icon";

interface Props {
  details: string[];
}

export default function LocationInfo({ details }: Props) {
  return (
    <View className="flex flex-row flex-wrap gap-x-2 gap-y-2.5">
      {details.map((detail, index) => (
        <View className="flex flex-row items-center gap-x-2" key={index}>
          <Text className="text-sm text-typography-700">{detail}</Text>
          {index < details.length - 1 ? (
            <Icon
              as={CircleIcon}
              className="text-gray-300 w-2 h-2 fill-gray-300"
            />
          ) : null}
        </View>
      ))}
    </View>
  );
}
